import { axiosInstance } from '@/modules/shared/lib/axios';
import { EmailConfigurationModel } from './types';

type Props = {
  companyId: string
}

export function getEmailConfigurationSettings ({ companyId }: Props) {
    return axiosInstance.get<EmailConfigurationModel>(`/api/${companyId}/configuration/email`);
}
